module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "collection_list"
    }
  }, [_c('ul', _vm._l((_vm.collections), function(collection) {
    return _c('li', [_c('router-link', {
      staticClass: "galleries",
      attrs: {
        "to": {
          name: 'collection',
          params: {
            collection: collection.pk
          }
        }
      }
    }, [_vm._v(_vm._s(_vm._f("capitalize")(collection.title)))])], 1)
  }))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "collection_view"
    }
  }, [_c('router-view')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dd7288f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Gallery.vue
// module id = 9
// module chunks = 0